import React from "react";
import "./About.css";
 import { AppContext } from "../context/Context";
const ContactSupport = () => {
  const { siteSetting, loading } = React.useContext(AppContext);
  if (loading || !siteSetting) return null;
  return (
    
<section className="contact-support-section">
<div className="container">
        {/* Header */}
<div className="contact-support-header">
<span className="contact-support-badge">GET IN TOUCH</span>
<h2 className="contact-support-title">Contact and Support</h2>
<p className="contact-support-subtitle">
            For assistance, queries, or feedback regarding the CSR Portal
</p>
</div>
 
        {/* Cards */}
<div className="contact-support-grid">
          {/* Email */}
<div className="contact-support-card">
<div className="contact-support-strip blue">
<i className="fa-regular fa-envelope"></i>
</div>
<h4>Email Support</h4>
<p>For general queries and support</p>
<a href={`mailto:${siteSetting.email}`}>
              {siteSetting.email}
</a>
</div>
 
          {/* Phone */}
<div className="contact-support-card">
<div className="contact-support-strip green">
<i className="fa-solid fa-phone"></i>
</div>
<h4>Helpdesk</h4>
              {siteSetting.mobile}
<p>{siteSetting.visiting_hours}</p>
<span className="contact-support-link">
</span>
</div>
 
          {/* Address */}
<div className="contact-support-card">
<div className="contact-support-strip yellow">
<i className="fa-solid fa-location-dot"></i>
</div>
<h4>Office Address</h4>
<p>
              {siteSetting.office_name}

              {siteSetting.address}
</p>
</div>
</div>
</div>
</section>
  );
};
 
export default ContactSupport;